import type { StageKind } from '../model/types'

export const STAGE_KINDS: Array<{ slug: StageKind; name: string }> = [
  { slug: 'challenges', name: 'Desafios' },
  { slug: 'form', name: 'Formulário' },
  { slug: 'quiz', name: 'Quiz' },
  { slug: 'rewards', name: 'Recompensas' }
]

export const isQuizStage = (stage: { stage_kind: string }): boolean =>
  stage.stage_kind === 'quiz'
